import React from "react"
import { Link } from 'gatsby'
import { DropDown, DropDownList, DropDownListItem } from "./dropdown";


function FinancingDropdown({ isActive }) {
  return (
    <DropDown className={`dropdown-menu dropdown-mega-menu dropdown-mega-two ${isActive ? 'active' : ''}`}>
        <DropDownList className="dropdown-mega-list dropdown-two-column">           
              <DropDownListItem className="dropdown-listItem"><Link to="/idaho/">Idaho</Link></DropDownListItem>
              <DropDownListItem className="dropdown-listItem"><Link to="/montana/">Montana</Link></DropDownListItem>            
              <DropDownListItem className="dropdown-listItem"><Link to="/oregon/">Oregon</Link></DropDownListItem>
              <DropDownListItem className="dropdown-listItem"><Link to="/washington/">Washington</Link></DropDownListItem>
              <DropDownListItem className="dropdown-listItem"><Link to="/utah/">Utah</Link></DropDownListItem>
              <DropDownListItem className="dropdown-listItem"><Link to="/colorado/">Colorado</Link></DropDownListItem>     
              <DropDownListItem className="dropdown-listItem"><Link to="/wyoming/">Wyoming</Link></DropDownListItem>     

              <DropDownListItem className="dropdown-listItem"><Link to="/alabama/">Alabama</Link></DropDownListItem>
              <DropDownListItem className="dropdown-listItem"><Link to="/north-carolina/">North Carolina</Link></DropDownListItem>
              <DropDownListItem className="dropdown-listItem"><Link to="/florida/">Florida</Link></DropDownListItem>
              <DropDownListItem className="dropdown-listItem"><Link to="/texas/">Texas</Link></DropDownListItem>
              <DropDownListItem className="dropdown-listItem"><Link to="/georgia/">Georgia</Link></DropDownListItem>
              <DropDownListItem className="dropdown-listItem"><Link to="/arkansas/">Arkansas</Link></DropDownListItem>
              <DropDownListItem className="dropdown-listItem"><Link to="/virginia/">Virginia</Link></DropDownListItem>
              <DropDownListItem className="dropdown-listItem"><Link to="/tennessee/">Tennessee</Link></DropDownListItem>
              <DropDownListItem className="dropdown-listItem"><Link to="/ohio/">Ohio</Link></DropDownListItem>
           
        </DropDownList>
    </DropDown>
  )
}

export default FinancingDropdown